import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const COLORS = { protein: "#4C9AFF", carb: "#34C759", fat: "#FF9500" };

export default function MacroChart({ protein, carb, fat, size = 200, total = null }) {
  const data = [
    { name: "Protein", key: "protein", grams: protein, kcal: protein * 4 },
    { name: "Carbs", key: "carb", grams: carb, kcal: carb * 4 },
    { name: "Fat", key: "fat", grams: fat, kcal: fat * 9 },
  ];
  const totalKcal = data.reduce((s, d) => s + d.kcal, 0);

  return (
    <div className="relative" style={{ width: size, height: size }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data} dataKey="kcal" nameKey="name"
            innerRadius={size * 0.32} outerRadius={size * 0.48}
            paddingAngle={2} stroke="none"
          >
            {data.map((d) => <Cell key={d.key} fill={COLORS[d.key]} />)}
          </Pie>
          <Tooltip
            contentStyle={{ background: "#141414", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 0, color: "#fff" }}
            itemStyle={{ color: "#fff" }}
            labelStyle={{ color: "#fff" }}
            formatter={(v, n, p) => [`${p.payload.grams}g`, p.payload.name]}
          />
        </PieChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
        <span className="font-display font-bold text-2xl text-white">{total != null ? total : Math.round(totalKcal)}</span>
        <span className="text-[10px] uppercase tracking-[0.2em] text-zinc-200">kcal</span>
      </div>
    </div>
  );
}
